import { Textarea, Label } from '@creanizer/ui'
import type { CharacterThinkingProcess } from '@creanizer/types'

interface ThinkingProcessEditorProps {
  thinkingProcess: CharacterThinkingProcess
  onChange: (thinkingProcess: CharacterThinkingProcess) => void
}

export function ThinkingProcessEditor({
  thinkingProcess,
  onChange
}: ThinkingProcessEditorProps) {
  const handleChange = (field: keyof CharacterThinkingProcess, value: string) => {
    onChange({
      ...thinkingProcess,
      [field]: value
    })
  }

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="problemSolvingApproach">問題解決アプローチ</Label>
        <Textarea
          id="problemSolvingApproach"
          value={thinkingProcess.problemSolvingApproach || ''}
          onChange={(e) => handleChange('problemSolvingApproach', e.target.value)}
          placeholder="例: まず情報を集め、論理的に分析してから行動する"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="crisisJudgment">危機時の判断傾向</Label>
        <Textarea
          id="crisisJudgment"
          value={thinkingProcess.crisisJudgment || ''}
          onChange={(e) => handleChange('crisisJudgment', e.target.value)}
          placeholder="例: 冷静さを保ちつつも、仲間の安全を最優先する"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="prioritization">優先順位の付け方</Label>
        <Textarea
          id="prioritization"
          value={thinkingProcess.prioritization || ''}
          onChange={(e) => handleChange('prioritization', e.target.value)}
          placeholder="例: 人命＞任務＞自分の安全の順で優先する"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="planningAbility">計画性の有無</Label>
        <Textarea
          id="planningAbility"
          value={thinkingProcess.planningAbility || ''}
          onChange={(e) => handleChange('planningAbility', e.target.value)}
          placeholder="例: 綿密な計画を立てるが、想定外の事態には弱い"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="intuitionLogicBalance">直感と論理のバランス</Label>
        <Textarea
          id="intuitionLogicBalance"
          value={thinkingProcess.intuitionLogicBalance || ''}
          onChange={(e) => handleChange('intuitionLogicBalance', e.target.value)}
          placeholder="例: 普段は論理的だが、最終判断は直感を信じる"
          rows={2}
          className="mt-1"
        />
      </div>
    </div>
  )
}
